import { version } from './version';

export const environment = {
  name: "customer-dashboard",
  production: true,
  doRedirectToAdminBoard: true,
  version: version
};
